import { atom } from 'jotai';
import { TagInfo } from '@/interfaces/tag';
import { getTags } from '@/apis/tag';
import { errorHandler } from '@/utils/request';

export const tagsDataAtom = atom<TagInfo[]>([]);
export const tagsMapDataAtom = atom<Record<number, TagInfo>>({});

export const tagsAtom = atom(
  (get) => ({ tags: get(tagsDataAtom), tagsMap: get(tagsMapDataAtom) }),
  (get, set) => {
    getTags()
      .then((tags) => {
        set(tagsDataAtom, tags);
        set(
          tagsMapDataAtom,
          tags.reduce(
            (res, tag) => {
              res[tag.id] = tag;
              return res;
            },
            {} as Record<number, TagInfo>,
          ),
        );
      })
      .catch(errorHandler);
  },
);
